import { Injectable } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as $ from 'jquery';

@Injectable()
export class FlashService {

  constructor(public flashMessage:FlashMessagesService) { }

  flashTracker = {};


  flashElementWithId(elementId, message, seconds){
    console.log('inside flashElementWithId for', elementId);
    //add element to the flashTracker w/ initial count of 0
    if (!this.flashTracker[elementId]){
      this.flashTracker[elementId] = 0;
    }

    //increment the flashCount for elementId
    this.flashTracker[elementId] += 1;    
    //show the element w/ message
    $(elementId).html(message);
    $(elementId).show();
    //in x seconds, reduce counter and hide element
    setTimeout(() => {
      console.log('timeout set for elementId', elementId);
      this.flashTracker[elementId] -= 1;
      if(this.flashTracker[elementId] == 0){
        $(elementId).hide();
      }
    }, seconds);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/utility/flash.service.ts